export default __webpack_public_path__ + "static/media/guiaWindows1.39670bf2.png";